type Variant = 'default' | 'lite'
export type ItemStatus = 'En cours' | 'Terminé'

export default function StatusPill({ status, variant = 'default' }: { status?: ItemStatus; variant?: Variant }) {
  if (status !== 'En cours') return null

  const isLite = variant === 'lite'
  return (
    <span
      className={
        isLite
          ? 'inline-flex items-center rounded-full border border-emerald-400/30 bg-emerald-400/10 px-2.5 py-1 text-[11px] font-bold tracking-wide text-emerald-200'
          : 'inline-flex items-center rounded-full border border-emerald-400/25 bg-emerald-400/10 px-2.5 py-1 text-[11px] font-semibold tracking-wide text-emerald-200'
      }
    >
      En cours
    </span>
  )
}


